import styled from "@emotion/styled";
import { IconButton } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import InterpolationTooltipData from "./InterpolationTooltipData";
import InterPolationIcon from "../../assets/icons/interpolation.png";
import { useSelector } from "react-redux";

const NoMaxWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
    />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        background: "linear-gradient(90deg, rgba(191, 242, 255, 1) 0%, rgba(195, 215, 255, 1) 100%)",
        borderRadius: "5px",
        padding: "5px",
    },
});

function InterpolationDetailsTooltip() {
    const interpolationDetails = useSelector((state) => state.matchNetStore.interpolationDetails);

    return (
        Object.keys(interpolationDetails).length > 0 && (
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    position: "sticky",
                    left: 0,
                }}
            >
                <NoMaxWidthTooltip
                    title={
                        <div
                            style={{
                                maxHeight: "80vh",
                                overflowY: "auto",
                            }}
                        >
                            {" "}
                            <InterpolationTooltipData interpolationDetails={interpolationDetails} />
                        </div>
                    }
                    placement="left-start"
                    leaveDelay={500}
                >
                    <IconButton
                        aria-label="open"
                        sx={{
                            background: "rgb(51, 94, 234) !important",
                            color: "#fff",
                        }}
                        size="small"
                    >
                        <img
                            src={InterPolationIcon}
                            alt="Interpolation"
                            style={{
                                width: 25,
                                height: 25,
                            }}
                        />
                    </IconButton>
                </NoMaxWidthTooltip>
            </div>
        )
    );
}

export default InterpolationDetailsTooltip;
